import { CHAT_URL, AGENT_CHAT_URL } from '../define/index'
import WS from '../api/ws'
import request from '../api/request'
import { findIndex, concat, assign, isUndefined } from 'lodash'

const ChatEvent = {
  userOnline: 'userOnline',
  userOffline: 'userOffline',
  changeUserList: 'changeUserList',
  changeUserManual: 'changeUserManual',
  messageMore: 'messageMore',
  userMessage: 'userMessage'
}

export default {
  props: {
    userId: {
      type: Number,
      default: 0
    },
    personId: {
      type: Number,
      default: 0
    }
  },
  data: function() {
    return {
      userList: [],
      messageList: [],
      message: {},
      userRisk: {},
      faqList: []
    }
  },
  computed: {
    userInfo: function() {
      const index = findIndex(this.userList, u => u.uid === this.userId)
      if (index > -1) {
        return this.userList[index]
      } else {
        return {}
      }
    },
    riskData: function() {
      const uid = this.personId || this.userId
      
      if (uid > 0 && this.userRisk[uid]) {
        return this.userRisk[uid]
      } else {
        return {}
      }
    }
  },
  watch: {
    userId() {
      this.sendMessageHistory(this.userId)
      const index = findIndex(this.userList, u => u.uid === this.userId)
      if (!isUndefined(this.userList[index]['unread'])) {
        this.userList[index]['unread'] = 0
      }
    }
  },
  destroyed() {
    this.ws.close()
    this.ws = null
  },
  methods: {
    initWS: function() {
      this.ws = WS.create({
        url: (this.personId ? AGENT_CHAT_URL : CHAT_URL) + (this.userId ? `?user_id=${this.personId || this.userId}` : ''),
        onStatus: this.handleChangeStatus,
        onMessage: this.handleMessage
      })
    },
    getUserList: function() {
      this.ws.send(WS.ReqType.userList)
    },
    handleChangeStatus: function(status) {
      if (status === WS.Status.connected) {
        if (this.userId) {
          this.sendMessageHistory(this.personId || this.userId)
        }
        this.getUserList()
      } else if (status === WS.Status.authRequired) {
        this.$router.push('/login')
      }
    },
    handleMessage: function(type, data) {
      if (WS.RespType.userList === type) {
        this.updateUserList(data)
      } else if (WS.RespType.history === type) {
        if (data['list']) {
          this.messageList = concat(data.list, this.messageList)
        }
      } else if (WS.RespType.statusChanged === type) {
        this.updateUserStatus(data)
      } else if (WS.RespType.message === type) {
        if (WS.Role.admin === data.to.type && WS.Role.ai === data.from.type) {
          this.faqList = data.body.message.split('\n')
        } else {
          this.updateMessage(data)
        }
      } else if (WS.RespType.error === type) {
        this.$message.error(data.err)
      }
      this.$emit(type, data)
    },
    updateMessage: function(msg) {
      const uid = msg.from.type === WS.Role.user || msg.from.type === WS.Role.agentInteract ? msg.from.id : msg.to.id

      if (msg.to.type === WS.Role.user || msg.from.type === WS.Role.user
        || msg.to.type === WS.Role.agentInteract || msg.from.type === WS.Role.agentInteract
      ) {
        if (msg.body.actions) {
          for (let action of msg.body.actions) {
            if (action.type === 'chart_data') {
              this.$set(this.userRisk, uid + '', action.data)
            }
          }
        }
        const index = findIndex(this.userList, u => u.uid === uid)
        if (uid === this.userId || uid === this.personId) {
          this.messageList.push(msg)
        } else if (msg.from.type === WS.Role.user || msg.from.type === WS.Role.agentInteract) {
          if (isUndefined(this.userList[index]['unread'])) {
            this.userList[index]['unread'] = 1
          } else {
            this.userList[index]['unread']++
          }
        }
        if (this.userList[index]) {
          this.userList[index]['last_say'] = msg.time
        }
      }
    },
    updateUserList: function(data) {
      const list = this.userList
      for (let user of data['list'] || []) {
        let index = findIndex(list, u => u.uid === user.uid)
        let manual = data.manual ? data.manual.find(m => m.role.id === user.uid) : null
        if (manual) {
          user.manual = manual.manual
        }
        user.unread = 0
        if (index === -1) {
          list.push(user)
        } else {
          list[index] = user
        }
      }
      window.console.debug('user list', list)
      this.userList = list
      this.getUserInfo()
    },
    getUserInfo: function() {
      const uid_list = this.userList.filter(u => !u['nickName']).map(u => u.uid).slice(0, 100)

      if (uid_list.length > 0) {
        request.front
          .post("user_get_oauth_data", {
            uid_list: uid_list
          })
          .then(resp => {
            for (let u of resp.data["list"]) {
              try {
                let data = u.info;
                data.headimgurl = data.headimgurl.replace(
                  "http://",
                  "https://"
                );
                data.mobile = u.mobile;
                const index = findIndex(
                  this.userList,
                  user => user.uid === u.user_id
                );
                if (index > -1) {
                  data = assign(this.userList[index], data);
                  this.userList[index] = data;
                  this.$set(this.userList, index, data);
                }
              } catch (e) {
                window.console.error(u);
              }
            }
            this.$emit("changeUserList", this.userList);
          });
      }
    },
    updateUserStatus: function(data) {
      const index = findIndex(this.userList, u => u.uid === data.role.id)
      if (index > -1) {
        this.userList[index].online = data.online
        this.$set(this.userList, index, this.userList[index])
      } else {
        this.userList.push({ uid: data.role.id, online: data.online, manual: data.manual })
      }
      if (data.online) {
        this.getUserInfo()
      }
      this.$emit(data.online ? ChatEvent.userOnline : ChatEvent.userOffline, data.role.id)
    },
    sendMessage: function(uid, msg) {
      this.ws.send(WS.ReqType.message, {
        to: {
          type: WS.Role.user,
          id: uid
        },
        subject: WS.Subject.text,
        body: {
          message: msg
        }
      })
    },
    sendManualStats: function(uid, status) {
      this.ws.send(WS.ReqType.manual, {
        role: { type: WS.Role.user, id: uid },
        manual: status
      })
    },
    sendMessageMore: function(uid, range) {
      this.ws.send(WS.ReqType.history, {
        role: { 
          type: this.personId ? WS.Role.agentInteract : WS.Role.user, 
          id: uid },
        range: range
      })
    },
    sendMessageHistory: function(uid) {
      this.messageList = []
      this.ws.send(WS.ReqType.history, {
        role: {
          type: this.personId ? WS.Role.agentInteract : WS.Role.user, 
          id: uid 
        }
      })
    },
    sendScript: function(uid, script) {
      this.ws.send(WS.ReqType.message, {
        to: { type: WS.Role.vmx },
        subject: WS.Subject.subjectPushScript,
        body: {
          uid: uid,
          scene: script
        }
      })
    },
    searchFAQ: function(msg) {
      this.ws.send(WS.ReqType.message, {
        to: { type: WS.Role.ai },
        subject: WS.Subject.text,
        body: { message: msg }
      })
    }
  }
}

